/**
 * An icon for each slot-machine value, so the reels read at a glance from the
 * back of the room. Anything not listed (an item an administrator adds) gets a
 * steady pick from a fallback set, so it always shows the same icon.
 */

const AGENCY: Record<string, string> = {
  'Department of Homeland Security': '🛡️',
  'U.S. Customs and Border Protection': '🛂',
  'U.S. Immigration and Customs Enforcement': '🚔',
  'Transportation Security Administration': '🧳',
  'Cybersecurity and Infrastructure Security Agency': '🔐',
  'U.S. Secret Service': '🕶️',
  'U.S. Citizenship and Immigration Services': '🗽',
  'Federal Emergency Management Agency': '🌪️',
  'Federal Bureau of Investigation': '🔎',
  'U.S. Department of State': '🌐',
  'U.S. Department of Agriculture': '🌾',
  'Department of the Treasury': '💵',
  'U.S. Department of the Interior': '🏞️',
  'Department of Housing and Urban Development': '🏠',
  'Food and Drug Administration': '💊',
  'Federal Aviation Administration': '✈️',
  'Department of Commerce': '📈',
  'National Telecommunications and Information Administration': '📡',
  'U.S. Department of Education': '🎓',
  'General Services Administration': '🏢',
  'National Science Foundation': '🔬',
  'Federal Deposit Insurance Corporation': '🏦',
  'Peace Corps': '🕊️',
  'National Gallery of Art': '🖼️',
}

const DOMAIN: Record<string, string> = {
  'Acquisition Management': '🛒',
  'Grants Management': '💰',
  'Human Capital Management': '👥',
  'Asset Management': '💻',
  'Facilities Management': '🏗️',
  Geospatial: '🗺️',
  'Learning Management': '📚',
  'Case Management': '🗂️',
  'Benefits Delivery': '🎁',
  'Permitting and Licensing': '📝',
  'Emergency Management': '🚨',
  'Records Management': '🗄️',
  Cybersecurity: '🔒',
  'Financial Management': '🧾',
  'Customer Experience': '😊',
  'Compliance and Inspections': '✅',
}

const TECHNOLOGY: Record<string, string> = {
  'AI Assistant': '🤖',
  'Data Dashboard': '📊',
  'Mobile App': '📱',
  'Self-Service Portal': '🖥️',
  'Workflow Automation': '⚙️',
  'Search Engine': '🔍',
  'Interactive Map': '🗺️',
  'Smart Form': '📋',
}

const FALLBACK = ['⭐', '🚀', '💡', '🎯', '🧩', '🔥', '⚡', '🌟', '🎲', '🧱']

const steady = (value: string) => FALLBACK[[...value].reduce((sum, ch) => sum + ch.charCodeAt(0), 0) % FALLBACK.length]

export type ReelKind = 'agency' | 'domain' | 'technology'

const TABLES: Record<ReelKind, Record<string, string>> = { agency: AGENCY, domain: DOMAIN, technology: TECHNOLOGY }

export function iconFor(kind: ReelKind, value: string): string {
  return TABLES[kind][value] ?? steady(value)
}
